import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import {
  FormBase,
  FormBaseControlService,
  GTagService,
} from '@mapfre-design-library/src/public_api';

// --- Components | Services | Models --- //
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { AddPolicyDataService } from './../../../../_services/signup-process-service/add-policy-data.service';
import { UserService } from '../../../../_services/user.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-edit-policy-form',
  templateUrl: './edit-policy.component.html',
  providers: [FormBaseControlService],
})
export class EditPolicyComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  @Input() userData: any;
  editPolicyForm: FormGroup;
  loading = false;
  user: any = {};
  init = true;
  loader = false;
  isCommercialAc: any;
  constructor(
    private addPolicyDataService: AddPolicyDataService,
    private authService: AuthenticationService,
    private ipt: FormBaseControlService,
    public router: Router,
    private userService: UserService,
    private gTagService: GTagService,
    private translate: TranslateService
  ) {}

  createUserObject(object): object {
    const policyNumber =
      object.editPolicyNumber != ''
        ? object.editPolicyNumber.trim()
        : object.editPolicyNumber;
    const policyDetail = {
        policynumber: { policyNumber },
      },
      updatedUserAndPolicy = {
        userDetails: {
          firstName: object.editFirst_name
            ? object.editFirst_name.trim()
            : object.editCompany_name.trim(),
          middleName: object.editMI_name ? object.editMI_name.trim() : '',
          lastName: object.editLast_name ? object.editLast_name.trim() : '',
          email: {
            address: object.editEmail ? object.editEmail : '',
          },
        },
        policyDetail: { ...policyDetail },
      };
    return updatedUserAndPolicy;
  }

  editPolicy(): void {
    const updatedUserAndPolicy: any = this.createUserObject(
      this.editPolicyForm.value
    );
    const policynumber =
      updatedUserAndPolicy['policyDetail'].policynumber.policyNumber;
    this.addPolicyDataService.updateAddPolicy(updatedUserAndPolicy);
    this.loader = true;
    if (
      policynumber &&
      policynumber.startsWith('800803') &&
      policynumber.length === 13
    ) {
      if (this.router.url === '/my-insurance/link-policy') {
        this.router.navigate([
          '/my-insurance',
          'business-policy-not-supported',
        ]);
      } else {
        this.router.navigate(['signup', 'bop']);
      }
      this.loader = false;
    } else {
      this.authService.verifyPolicy(updatedUserAndPolicy).subscribe(
        (response: any) => {
          this.loader = false;
          this.gTagService.triggerFormLink('editPolicyForm', 'true', '');
          // this.policyService.updatePolicyDetails(response); //new code
          // policy not linked and exists in as400
          if (response) {
            if (this.router.url === '/my-insurance/edit-policy-details') {
              this.router.navigate(['/my-insurance', 'validate-policy-rights']);
            } else {
              const publicId = response.insured.filter((insurer) => {
                if (updatedUserAndPolicy.userDetails.lastName === '') {
                  return (
                    insurer['Insured Name'].toLowerCase() ===
                    updatedUserAndPolicy.userDetails.firstName.toLowerCase()
                  );
                } else {
                  return (
                    insurer.firstName.toLowerCase() ===
                      updatedUserAndPolicy.userDetails.firstName.toLowerCase() &&
                    insurer.lastName.toLowerCase() ===
                      updatedUserAndPolicy.userDetails.lastName.toLowerCase()
                  );
                }
              });
              updatedUserAndPolicy.userDetails['publicId'] =
                publicId.length > 0 ? publicId[0].publicId : null;
              this.userService.updateUser(updatedUserAndPolicy);
              this.router.navigate(['signup', 'validate-email-ca']);
            }
          }
        },
        (err) => {
          this.loader = false;
          this.gTagService.triggerFormLink(
            'editPolicyForm',
            'false',
            this.translate.instant('EDIT_POLICY_ERROR')
          );
          if (err.status === 404) {
            // 404 - if the policy belongs to another account
            // Set policy number using user observable in policy details key
            this.user.policyDetail = this.editPolicyForm.value.editPolicyNumber;
            this.user.b2cEmail = err.error.Message;
            this.userService.updateUser(this.user);
          }
          if (err.status === 504) {
            this.router.navigate(['signup', 'validate-email-ca']);
          }
          if (err.status !== 504) {
          this.addPolicyDataService.addPolicyErrorHandler(err, policynumber);
          }
        }
      );
    }
  }

  prefillData(prefillData): void {
    if (this.isCommercialAc) {
      this.editPolicyForm
        .get('editCompany_name')
        .setValue(prefillData.userDetails.firstName);
      this.editPolicyForm
        .get('editEmail')
        .setValue(prefillData.userDetails.email.address);
    } else {
      this.editPolicyForm
        .get('editFirst_name')
        .setValue(prefillData.userDetails.firstName);
      this.editPolicyForm
        .get('editMI_name')
        .setValue(prefillData.userDetails.middleName);
      this.editPolicyForm
        .get('editLast_name')
        .setValue(prefillData.userDetails.lastName);
      this.editPolicyForm
        .get('editDob')
        .setValue(prefillData.userDetails.dateOfBirth);
    }
    this.editPolicyForm
      .get('editPolicyNumber')
      .setValue(prefillData.policyDetail.policynumber.policyNumber);
  }

  ngOnInit() {
    this.editPolicyForm = this.ipt.toFormGroup(this.inputs);
    this.isCommercialAc = this.userService.getCommercialAcFlag();
    if (this.init) {
      this.addPolicyDataService.$newPolicy.subscribe((userData) => {
        this.prefillData(userData);
      });
    }
  }
}
